module.exports = require('ember-lazy-list').ItemView.extend(require('./option-view-mixin'));